export const getColors = () => {
    const style = getComputedStyle(document.body);
    return {
        success: style.getPropertyValue('--color-success'),
        error: style.getPropertyValue('--color-error'),
        primary: style.getPropertyValue('--color-primary'),
        darkGray: style.getPropertyValue('--color-muted60'),
    };
};

export const URLKeys = {
    firstMember: 'prvni_clen',
    secondMember: 'druhy_clen',
    member: 'zastupitel',
    party: 'subjekt',
    sortBy: 'razeni',
    selectedYear: 'rok',
    page: 'strana',
    rows: 'pocet_vysledku',
    voteDescription: 'popis_hlasovani',
    memberNumber: 'id_zastupitele',
    memberVote: 'hlasovani_zastupitele',
    voteResult: 'vysledek_hlasovani',
    meetingNumber: 'cislo_zasedani',
    show: 'zobrazit',
    VotingTypes:{
        secretVotes: 'tajne',
        invalidVotes: 'neplatne',
        proceduralVotes: 'proceduralni',   
    },
    voteDescriptionText: 'popis_hlasovani_text',
    fullText: 'cely_text',
} as const;

const BASENAME = process.env.REACT_APP_BASENAME;
const USE_ADMIN = '1';
const AUTHORIZATION = process.env.REACT_APP_AUTHORIZATION;
const API_BASEURL = process.env.REACT_APP_API;
const ENABLE_I18N = process.env.REACT_APP_ENABLE_I18N === 'true';
const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;
const PAGE_WARNING = process.env.REACT_APP_PAGE_WARNING;
const PUBLIC_URL = process.env.PUBLIC_URL;
// Mirrors the backend USE_STATS_DB flag: the geo/stats label and Stats page endpoints
// only work when the backend has a configured `statsdb` Mongo connection.
const ENABLE_STATS = process.env.REACT_APP_ENABLE_STATS === 'true';
// Pins the deployment to one municipality, dropping the `:municipalitaId` URL segment
// entirely - see src/utils/councilParams.ts. Body type and council term are unaffected.
const SINGLE_MUNICIPALITY_ID = process.env.REACT_APP_SINGLE_MUNICIPALITY_ID || null;

export const STATS_DEFAULT_GEO    = 'cz'
export const STATS_DEFAULT_METRIC = 'nezam'

export {
    BASENAME,
    USE_ADMIN,
    AUTHORIZATION,
    API_BASEURL,
    ENABLE_I18N,
    GA_TRACKING_ID,
    PAGE_WARNING,
    PUBLIC_URL,
    ENABLE_STATS,
    SINGLE_MUNICIPALITY_ID
};
